import React from "react";
import { Modal } from "antd";

const ConfirmModifyModal = ({
  visible,
  onOk,
  onCancel,
  content,
}) => {
  return (
    <Modal
      title="Are you sure?"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Yes"
      okButtonProps={{
        style: {
          backgroundColor: "#4E36A3",
          color: "white",
          height: "40px",
          width: "100px",
        },
      }}
      cancelButtonProps={{
        style: {
          color: "#4E36A3",
          height: "40px",
          width: "100px",
        },
      }}
    >
      <h1>{content}</h1>
    </Modal>
  );
};

export default ConfirmModifyModal;
